export const COMMERCIAL_GESTURE = 'Commercial Gesture';
export const MEDICAL_CONDITION = 'Medical Condition';
export const PARTIAL_COMMERCIAL_GESTURE = 'Partial Commercial Gesture';
export const VAT_CORRECTION = 'VAT Correction';
export const VAT = 'VAT';
export const WITHDRAWAL_PERIOD = 'Withdrawal Period';

export const subscriptionCancellationReasons = [
  {
    value: COMMERCIAL_GESTURE,
    label: COMMERCIAL_GESTURE
  },
  {
    value: MEDICAL_CONDITION,
    label: MEDICAL_CONDITION
  },
  {
    value: PARTIAL_COMMERCIAL_GESTURE,
    label: PARTIAL_COMMERCIAL_GESTURE
  },
  {
    value: VAT,
    label: VAT_CORRECTION
  },
  {
    value: WITHDRAWAL_PERIOD,
    label: WITHDRAWAL_PERIOD
  }
];
